module.exports = __webpack_public_path__ + "static/img/pingjie4.89f83914.png";